import { BaseTelemetryEvent, Telemetry } from '~src/commonInfra/services/Telemetry';

import { SpringError } from '../types/DraftsTypes';

// Matches with the table in Project Endeavor
export enum DraftsTelemetryEvents {
  requestFailed = 'DraftsTelemetry_requestFailed',
  openExistingDraft = 'DraftsTelemetry_OpenExistingDraft',
  discardDraft = 'DraftsTelemetry_DiscardDraft',
}

export interface DraftsRequestFailedEvent extends BaseTelemetryEvent, SpringError {
  url: string;
  httpErrorCode: number;
}

export interface DraftsEntryEvent extends BaseTelemetryEvent {
  success: boolean;
  error_message?: string;
  origin: DraftsTelemetry.LocationOrigin;
  workbook_luid?: string;
  draft_luid?: string;
}

export namespace DraftsTelemetry {

  export type LocationOrigin =
    'DraftBanner_ContinueEditing'
    | 'DraftBanner_DiscardChanges'
    | 'Thumbnail_ContinueEditing'
    | 'ActionMenu_EditWorkbook'
    | 'ActionMenu_EditView'
    | 'ActionMenu_DiscardChanges';

  export function sendDraftsOpenEvent(eventParams: Omit<DraftsEntryEvent, 'type'>) {
    const event: DraftsEntryEvent = {
      type: DraftsTelemetryEvents.openExistingDraft,
      ...eventParams
    };
    Telemetry.sendEvent(event);
  }

  export function sendDraftsDiscardEvent(eventParams: Omit<DraftsEntryEvent, 'type'>) {
    const event: DraftsEntryEvent = {
      type: DraftsTelemetryEvents.discardDraft,
      ...eventParams
    };
    Telemetry.sendEvent(event);
  }
}
